import { Type } from "class-transformer";
import { UserDto } from "@/core/features/users/user.dto";
import { PlanningBoardAbsenceTypeEnum } from "./planning-board-absence-type.enum";

export class PlanningBoardAbsenceAssignmentDto {
  @Type(() => UserDto)
  user: UserDto;

  type: PlanningBoardAbsenceTypeEnum;
  daysMask: number;
}
